import React from "react";
import { DropDownField } from "../../../helpers";
import { Button } from "../../../helpers";
import { Oval } from "react-loader-spinner";
import _ from "lodash";
import { getFullName } from "../../../utils";

const SellerStock = (props) =>{
    let { stockMaterials, handleOnAddStock, setIsStockVisible, isStockLoading } = props
   
    const handleAddClick = (stockWarehousId) => {
        handleOnAddStock(stockWarehousId, stockMaterials)
        setIsStockVisible(false)
    }

    stockMaterials = _.uniqBy(stockMaterials, "warehouseManagerId")
    return(
        <>
            {
                isStockLoading ? (
                    <div className="flex flex-column justify-content-between align-items-center">
                        <Oval
                            height={45}
                            width={45}
                            color="#00baac"
                            visible={true}
                            ariaLabel='oval-loading'
                            secondaryColor="#a4a7a6"
                        />
                    </div>
                ) : (
            
                stockMaterials?.length === 0 ? <p className="text-center">Selected material is not present in the stock.</p> : 
                    <div className="p-card">
                        {
                            stockMaterials?.map(eachMaterial => {
                                let name = getFullName(eachMaterial?.firstName, eachMaterial?.lastName)
                                return (
                                    <div className="seller-company-collection flex flex-column">
                                        <div className="flex flex-row justify-content-between p-2 border-bottom-1 border-300">
                                            <div> <p> {eachMaterial.materialId} | Stock Qty : {eachMaterial?.smartStock} | UnitPrice: <span>{eachMaterial?.unitPrice}</span>* | Seller : {name}</p></div>
                                            <div className="ml-2"><Button label="Add" style={{backgroundColor:"#26a69a"}} onClick={() => handleAddClick(eachMaterial?.stockWarehouseId)}/></div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                )
            }
        </>
    )
}
export default SellerStock;